import React, { Component } from 'react';
import './App.css';
import Project from './Project';
import projects from './projects.json';

function createSlug(name: string) {
  return name.toLowerCase().replace(/[ /]/g, '_');
}

class App extends Component {
  render() {
    const projectsDisplay = projects.map(p => (
      <Project
        key={createSlug(p.name)}
        name={p.name}
        year={p.year}
        description={p.description}
        link={p.link}
        images={p.images}
      />
    ));

    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Eric Lemieux</h1>
          <p>Below is a collection of some of the interesting projects I have worked on and I am allowed to talk about. These range from projects I worked on at university, to hobby projects, or to tooling I use at work.</p>
          <ul className="horizontal-links">
            <li>
              <a href="https://gitlab.com/EricLemieux">GitLab</a>
            </li>
          </ul>
        </header>
        <main className="projects-list">
          {projectsDisplay}
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js